export default __webpack_public_path__ + "static/media/classplusLogo.f84d48ff.svg";